var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.5,
    r: 10,
    fill: "#9E98AA",
    fillOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.6905C5 11.6905 6.07143 11.6905 7.5 14.1905C7.5 14.1905 11.4706 7.64286 15 6.33334",
    stroke: "#9A9A9A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactive);
export default __webpack_public_path__ + "static/media/inactive.238689cd06ed604e949aa0b4154c72de.svg";
export { ForwardRef as ReactComponent };